export const xyPositionRackItem = (
  index: number,
  rackType: [number, number]
): [number, number] => {
  const currIndex = rackType[0] * rackType[1] - 1 - index;

  const itemPositionW = (index % rackType[0]) + 1;
  const itemPositionH = Math.floor(currIndex / rackType[0]) + 1;

  return [itemPositionW, itemPositionH];
};

export const findIndexByXY = (
  XY: [number, number],
  rackType: [number, number]
): number => {
  const [x, y] = XY;
  // сначала считаем сколько секций от верха до низа по У
  const sectionsAbove = (rackType[1] - y) * rackType[0];
  // далее смотрим сколько нужно прибавить в ряду еще по Х
  const sectionsInRow = x === 1 ? 0 : x - 1;

  return sectionsAbove + sectionsInRow;
};
